export default defineNuxtRouteMiddleware(() => {
	const adminStore = useAdminAuthStore()
	const localePath = useLocalePath()
	if (!adminStore.state.user) return

	if (adminStore.isAdmin) return navigateTo(localePath('/panel/product-catalog'))
	if (adminStore.getPermission([EUserPermissions.CMS_PL, EUserPermissions.CMS_EN])) return navigateTo(localePath('/panel'))
})
